module.exports = __webpack_public_path__ + "media/images/Jessica_Paxson_MD-e13310ff00d016113d681c251aa0a3c3.png";